// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "dayOfWeekName_withPrices-sreYC";
export { _1 as "__esModule", _2 as "dayOfWeekName_withPrices" }
export default { "__esModule": _1, "dayOfWeekName_withPrices": _2 }
